function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Asset-Artboard-Page",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/YOUTUBE-ICONS/16/YOUTUBE"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 16,
  height: 16
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.31111111,9.4765625 L6.31111111,5.09375 L10.6666667,7.2421875 L6.31111111,9.4765625 Z M15.8222222,4.40625 C15.8222222,4.40625 15.6444444,3.375 15.2,2.859375 C14.5777778,2.2578125 13.8666667,2.2578125 13.6,2.171875 C11.3777778,2 8,2 8,2 L8,2 C8,2 4.62222222,2 2.4,2.171875 C2.04444444,2.171875 1.42222222,2.171875 0.8,2.859375 C0.355555556,3.2890625 0.177777778,4.40625 0.177777778,4.40625 C0.177777778,4.40625 0,5.6953125 0,6.8984375 L0,8.1015625 C0,9.390625 0.177777778,10.59375 0.177777778,10.59375 C0.177777778,10.59375 0.355555556,11.625 0.8,12.140625 C1.42222222,12.7421875 2.22222222,12.7421875 2.57777778,12.828125 C3.82222222,12.9140625 8,13 8,13 C8,13 11.3777778,13 13.6,12.828125 C13.9555556,12.828125 14.5777778,12.828125 15.2,12.140625 C15.6444444,11.7109375 15.8222222,10.59375 15.8222222,10.59375 C15.8222222,10.59375 16,9.3046875 16,8.1015625 L16,6.8984375 C16,6.0390625 15.9111111,5.265625 15.8222222,4.40625 Z",
  id: "SVGID_1_",
  fill: "#FFFFFF"
})));

var SvgYoutube = function SvgYoutube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube.96c01496.svg";
export { ForwardRef as ReactComponent };